import { Module } from 'vuex';
import { IoProductAPI } from '@/api';
import Benefit from '@/interfaces/BenefitInterface';

const benefitshowModule: Module<any, any> = {
  namespaced: true,

  state: {
    values: [] as Benefit[],
    loading: false,
    error: null,
  },

  mutations: {
    SET_LOADING(state, loading: boolean) {
      state.loading = loading;
    },
    SET_VALUES(state, values: Benefit[]) {
      state.values = values;
    },
    SET_ERROR(state, error: unknown) {
      state.error = error;
    },
  },

  actions: {
    fetch({ commit }, params) {
      commit('SET_LOADING', true);
      IoProductAPI.getBenefits(params)
        .then((data) => {
          commit('SET_ERROR', null);
          commit('SET_VALUES', data || []);
        }).catch((e: unknown) => {
          commit('SET_ERROR', e);
          commit('SET_VALUES', []);
        }).finally(() => {
          commit('SET_LOADING', false);
        });
    },
  },

  getters: {
    values: (state): Benefit[] => state.values || [],
    loading: (state): boolean => state.loading,
  },
};

export default benefitshowModule;
